import {
    EodSettingsApi,
    useAPIQuery,
} from "melco-shared-logic";



export const usePartners = () => {

    return useAPIQuery(
        EodSettingsApi,
        ["partners",],
        async (api) => {


            const response = await api.eodPartners()

            return response.list ?? [];

        }
    );
};
